export const permitQueryKeys = {
  base: ['permit'] as const,
  permitTypesCompanyLimits: (companyId: number) =>
    [...permitQueryKeys.base, 'permitTypesCompanyLimits', companyId] as const,
  permitTypeLimitInfo: (companyId: number, permitTypeId: number) =>
    [...permitQueryKeys.base, 'permitTypeLimitInfo', companyId, permitTypeId] as const,
  permitTypesForTenantType: (tenantType: string) =>
    [...permitQueryKeys.base, 'permitTypesForTenantType', tenantType] as const,
};
